const data = [
  {
    id: "1",
    question: "What are accordian components?",
    answer:
      "Accordion components are user interface elements used for  organizing and presenting content in a collapsible manner, They typically consist of a header, content, and an expand/ collapse action.",
  },
  {
    id: "2",
    question: "What are they used for?",
    answer:
      "The are commonly employed in various contexts, including FAQs, products descriptions, navigation menus, setting panels, and data tables, to save screen and provide a structured and user friendly interface for the presenting informations or options",
  },
  {
    id: "3",
    question: "Accordion is a musical instrument?",
    answer:
      "The accordion is a musical instrument with a keyboard and bellows. It produces sounds by air passing over the reeds when the player expands or compresses the bellows, used in various music genres.",
  },
  {
    id: "4",
    question: "Can I create an accordion component ?",
    answer:
      "Yes I can create, it is very possible to create an accordion components with another framework",
  },
];

export default data;
